import React, {memo, useEffect, useState} from "react";
import useStyles from "./useStyles";
import {DemoContainer, DemoItem} from "@mui/x-date-pickers/internals/demo";
import {LocalizationProvider} from "@mui/x-date-pickers-pro";
import {DateRangeCalendar} from "@mui/x-date-pickers-pro/DateRangeCalendar";
import dayjs from "dayjs";
import 'dayjs/locale/ru'
import {AdapterDayjs} from "@mui/x-date-pickers-pro/AdapterDayjs";

/*
* @dateFrom,
* @dateTo
* @onChange
* */

export const Calendar = memo((props) => {
  const classes = useStyles();

  const {
    dateFrom = new Date(),
    dateTo = new Date(),
    onChange = () => {}
  } = props

  const [calendarsCount, setCalendarsCount] = useState(3);

  useEffect(() => {
    const updateCalendars = () => {
      const mediaQueryMin = window.matchMedia("(max-width: 767px)");
      setCalendarsCount(mediaQueryMin.matches ? 1 : 3);
    };

    window.addEventListener("resize", updateCalendars);
    updateCalendars(); // Вызываем функцию при загрузке компонента
    return () => {
      window.removeEventListener("resize", updateCalendars);
    };
  }, []);

  const onChangeHandler = (value) => {
    onChange?.(value)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      <DemoContainer
        className={classes.container}
        components={["DateRangeCalendar"]}
      >
        <DemoItem>
          <DateRangeCalendar
            showDaysOutsideCurrentMonth
            fixedWeekNumber={6}
            className={classes.calendar}
            calendars={calendarsCount}
            defaultValue={[dayjs(dateFrom), dayjs(dateTo)]}
            value={[dayjs(dateFrom), dayjs(dateTo)]}
            onChange={onChangeHandler}
          />
        </DemoItem>
      </DemoContainer>
    </LocalizationProvider>
  );
});